export function revealWorkspace(root: HTMLElement, workspace: HTMLElement): void {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
  const fallback = root.querySelector<HTMLElement>('[data-marketing-fallback]')!
  const fallbackVisible = Number(getComputedStyle(fallback).opacity) > 0
  fallback.hidden = true
  if (reducedMotion.matches || fallbackVisible) {
    workspace.classList.remove('invisible')
    return
  }

  const textAnimations = Array.from(root.querySelectorAll('[data-marketing-hero-entrance]')).flatMap((text) =>
    text.getAnimations()
  )
  const textRemaining = Math.max(
    0,
    ...textAnimations.map(
      (entrance) => Number(entrance.effect!.getComputedTiming().endTime) - Number(entrance.currentTime)
    )
  )
  const animation = workspace.animate(
    { opacity: [0, 1] },
    { delay: textRemaining + 50, duration: 450, easing: 'ease-out', fill: 'both' }
  )
  workspace.inert = true
  workspace.classList.remove('invisible')

  const finishForReducedMotion = () => {
    if (reducedMotion.matches) animation.finish()
  }
  reducedMotion.addEventListener('change', finishForReducedMotion)
  animation.onfinish = () => {
    animation.cancel()
    workspace.inert = false
    reducedMotion.removeEventListener('change', finishForReducedMotion)
  }
}
